<template>
    <div>
        <input type="text" class="form-field" v-model="theValue" @keydown="triggerSearch">
        <template v-if="resultsShowing">
            <select class="mt-2" v-model="selectedResult">
                <option :value="null">-- {{ results.length }} results --</option>
                <option v-for="result in results" :key="result.company_number" :value="result">
                    {{ result.title }} ({{ result.company_number }})
                </option>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'CompaniesHouseSearch',
        props: {
            value: {
                type: String,
            },
        },
        data() {
            return {
                key: null,
                results: [],
                resultsShowing: false,
                theValue: null,
                selectedResult: null,
                searchTimer: null,
            }
        },
        mounted() {
            this.key = document.querySelector('meta[name="coho-key"]').getAttribute('content')
            this.theValue = this.value
        },
        methods: {
            triggerSearch() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer)
                }

                if (_.trim(this.theValue).length === 0) {
                    return
                }

                this.searchTimer = setTimeout(() => {
                    this.getCompaniesHouseData()
                }, 500)
            },
            /**
             * Load the data from companies house.
             */
            getCompaniesHouseData() {
                // We have to be crafty here and remove the common headers since CORS is in play.
                let a = axios.create({})
                delete a.defaults.headers.common['X-CSRF-TOKEN']
                delete a.defaults.headers.common['X-Requested-With']
                a.get('https://api.companieshouse.gov.uk/search/companies', {
                    params: {
                        q: this.theValue,
                        items_per_page: 250,
                    },
                    auth: {
                        username: this.key,
                    },
                    headers: {
                        'Accept': 'application/json',
                    },
                })
                    .then(response => {
                        this.results = [...response.data.items].filter(company => company.company_status === 'active')
                        this.resultsShowing = true
                        this.selectedResult = null
                    })
            },
        },
        watch: {
            theValue(newValue) {
                this.$emit('input', newValue)
            },
            selectedResult(newValue) {
                if (newValue === null) {
                    this.$emit('change', null)
                    this.theValue = null
                    this.resultsShowing = false

                    return
                }

                this.theValue = _.startCase(_.toLower(newValue.title))
                this.resultsShowing = false
                this.$emit('change', this.selectedResult)
            },
        }
    }
</script>
